module.exports = __webpack_public_path__ + "img/personal-web02.60aca5b9.png";